const FacebookStreamType =
{
	REGULAR:'REGULAR',
	AMBIENT:'AMBIENT'
}
export default FacebookStreamType;
